import { render, staticRenderFns } from "./ClimateOnlineStatistics.vue?vue&type=template&id=c18899a2"
import script from "./ClimateOnlineStatistics.vue?vue&type=script&lang=js"
export * from "./ClimateOnlineStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports